




























































































































































































































































































































































import { SwTabGroup, SwTabPage, TabProps } from '@sonicwall/unified-ui-framework/src/shared/sw-tab-layout';
import UUIFComponents from '@/shared/uuifComponent';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwTextarea } from '@libs-uuif/shared/sw-textfield';
import { SwModal ,  SwModalFooter , SwModalBody } from '@libs-uuif/shared/sw-modal';
import SupportFileUpload from './support-file-upload.vue';
// import { stubFalse } from 'lodash';
// import { currentUserKey } from './../../../shared/msw-constants';
// import axios from 'axios';

const cssPrefix = 'manage-case-details';
@Component({
  components: {
    ...UUIFComponents,
    SwTabGroup,
    SwTabPage,
    SwModal,
    SwModalFooter,
    SwModalBody,
    SwTextarea,
    SupportFileUpload,
  },
})
export default class SpecificCaseDetails extends SwExtendedVue {
  cssPrefix = cssPrefix;
  showCloseCaseModal: boolean = false;
  showAddCommentModal: boolean = false;
  closeCommentText: string = '';
  addCommentText: string = '';
  showTabDetails: boolean = false;
  showCommentError: boolean = false;
  showNotesHistory: boolean = false;
  fileUploadModal: boolean = false;
  notesData: any = {};
  caseTitleWithCaseNo: any;
  files: any = [];
  showInnerLoading: boolean = false;
  apiUrl: string = 'https://mswrestapi-blr-dev.eng.sonicwall.com/api';
  tabsProps: TabProps[] = [
    { tabId: 'reqInformation', label: (this.$t('caseDetails.tabName1')
    .toString()) },
    { tabId: 'reqHistory', label: (this.$t('caseDetails.tabName2')
    .toString()) },
  ];
  selectedTab: string = 'reqInformation';
  caseDisplayDetails : any = {};
  isCustomerSupport: boolean = false;
  get getModalWidth() {
    const width: string = '70%';
    return width;
  }
  parsedCaseDetails: any;
  @Prop()
  caseDetails : any;
  @Prop()
  showParticularCaseDetail: boolean;

  created() {
    console.warn(this.caseDetails);
    this.parsedCaseDetails = JSON.parse(this.caseDetails);
    this.getParticularSupportCase(JSON.parse(this.caseDetails).id);
    this.caseTitleWithCaseNo = `${(this.$t('caseDetails.caseNum')
    .toString())} ${JSON.parse(this.caseDetails).caseno}`;
    this.parsedCaseDetails.caseType === 'Customer Support' ? this.isCustomerSupport = true : this.isCustomerSupport = false;
  }
  getParticularSupportCase(id: any, fromSupportFile: boolean = false) {
    console.warn(fromSupportFile);
    if (!fromSupportFile) this.showTabDetails = false;
    if (!fromSupportFile) this.showInnerLoading = true;
    this.$store.dispatch('MswSupportCasesModule/getSupportCase', id)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp) {
          this.caseDisplayDetails = resp;
          this.showTabDetails = true;
          this.showInnerLoading = false;
        }
      })
      .catch((errResponse: any) => {
        console.error(errResponse);
        this.showInnerLoading = false;
      });
  }
  onClickAttachUrl(val: string) {
    window.open(val, '_blank');
  }
  closeCase() {
    this.showCommentError = false;
    this.closeCommentText = '';
    this.showCloseCaseModal = true;
  }
  addComment() {
    this.showCommentError = false;
    this.addCommentText = '';
    this.showAddCommentModal = true;
  }
  submitComment() {
    if (this.addCommentText === '') {
      this.showCommentError = true;
    } else {
      this.showAddCommentModal = false;
      this.showCommentError = false;
      const request = {
        caseId: JSON.parse(this.caseDetails).id,
        casecomment: this.addCommentText,
      };
      this.showTabDetails = false;
      this.showInnerLoading = true;
      this.$store.dispatch('MswSupportCasesModule/addCaseComment', request)
      .then((resp: any) => {
        if (resp.msgCode === 'MSWAPP:SUCCESS') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: 'Comment added to the case' });
          this.getParticularSupportCase(JSON.parse(this.caseDetails).id);
        } else {
          if (resp.msgDesc === null || resp.msgDesc === '') {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Something went wrong' });
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          }
          this.showInnerLoading = false;
          this.showTabDetails = true;
        }
      })
      .catch((errResponse: any) => {
        console.error(errResponse);
        this.showInnerLoading = false;
        this.showTabDetails = true;
      });
    }
  }
  submitCaseClose() {
    if (this.closeCommentText === '') {
      this.showCommentError = true;
    } else {
      this.showCommentError = false;
      this.showCloseCaseModal = false;
      const request = {
        caseId: JSON.parse(this.caseDetails).id,
        casecomment: this.closeCommentText,
        status: 'close',
      };
      this.showTabDetails = false;
      this.showInnerLoading = true;
      this.$store.dispatch('MswSupportCasesModule/caseClose', request)
      .then((resp: any) => {
        if (resp.msgCode === 'MSWAPP:SUCCESS') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: '' });
          this.getParticularSupportCase(JSON.parse(this.caseDetails).id);
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          this.showInnerLoading = false;
          this.showTabDetails = true;
        }
      })
      .catch((errResponse: any) => {
        console.error(errResponse);
        this.showInnerLoading = false;
        this.showTabDetails = true;
      });
    }
  }
  closeFileUpload(val: string) {
    this.fileUploadModal = false;
    if (val === 'fromManageCase') {
      this.getParticularSupportCase(JSON.parse(this.caseDetails).id, true);
    }
  }
  closeDialog() {
    this.$emit('close-case-detail-modal');
  }
  showNotes(index: any) {
    this.caseDisplayDetails.noteslist.forEach((item: any, i: number) => {
      if (index === i) {
        this.notesData.date = item.createddate;
        this.notesData.status = item.status;
        this.notesData.comment = item.notes;
        this.showNotesHistory = true;
      }
    });
  }
}
